
import React from 'react';
import { Mail } from 'lucide-react';

const ContactSection: React.FC = () => {
  return (
    <section id="contact" className="px-4 py-16 bg-white bg-opacity-70">
      <div className="container mx-auto max-w-3xl">
        <div className="text-center mb-12 animate-fade-in">
          <div className="inline-flex items-center justify-center space-x-2 mb-4">
            <Mail className="h-5 w-5 text-optout-blue" />
            <span className="font-medium text-optout-blue">Contact</span>
          </div>
          
          <h2 className="text-2xl md:text-3xl font-bold text-optout-text mb-4">
            Need Help?
          </h2>
          
          <p className="text-optout-lighttext max-w-2xl mx-auto text-balance">
            If you have any questions or need assistance with your opt-out request,
            please contact our customer support team.
          </p>
        </div>
        
        <div className="glass-card rounded-xl p-8 text-center animate-fade-in">
          <p className="text-optout-text mb-4">
            Our customer support team is available Monday through Friday, 9 AM to 5 PM.
          </p>
          
          <a 
            href="mailto:support@example.com" 
            className="text-optout-blue hover:text-optout-darkblue font-medium inline-block transition-colors duration-300"
          >
            support@example.com
          </a>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
